import { ReactNode } from 'react';
import styled from 'styled-components';

import { So5LeaderboardType } from '@sorare/core/src/__generated__/globalTypes';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Community } from 'components/landing/shared/Community';
import { FAQ } from 'components/landing/shared/FAQ';

import { Ambassadors } from './Ambassadors';
import { Compete } from './Compete';
import type { CompeteAssets } from './Compete';
import { Footer } from './Footer';
import { HeroVideo } from './HeroVideo';
import { Leagues } from './Leagues';
import { Needsyou } from './Needsyou';
import { Scout } from './Scout';
import type { ScoutAssets } from './Scout';
import { Win } from './Win';
import type { WinAssets } from './Win';

const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--quadruple-unit);
  overflow: hidden;
  position: relative;
  padding-bottom: var(--double-unit);
  @media ${tabletAndAbove} {
    gap: calc(8 * var(--unit));
  }
`;
const Hero = styled.div`
  @media ${tabletAndAbove} {
    margin-bottom: 100px;
  }
`;

type Props = {
  showFAQ?: boolean;
  showMbappeSection?: boolean;
  showOtherLeagues?: boolean;
  starPlayerSlug: string;
  assets: {
    scout: ScoutAssets;
    compete: CompeteAssets;
    win: WinAssets;
  };
  leaderboards: So5LeaderboardType[];
  league?: ReactNode;
};
const EarlyAccess = ({
  showFAQ,
  showMbappeSection = false,
  showOtherLeagues = false,
  starPlayerSlug,
  assets,
  leaderboards,
  league,
}: Props) => {
  return (
    <Root>
      <Hero>
        <HeroVideo league={league} />
        {showOtherLeagues && <Leagues />}
      </Hero>
      {showMbappeSection && <Needsyou />}
      <Scout assets={assets.scout} starPlayerSlug={starPlayerSlug} />
      <Compete assets={assets.compete} />
      <Container>
        <Win assets={assets.win} />
      </Container>
      <Community leaderboards={leaderboards} />
      <Container>
        <Ambassadors />
      </Container>
      <Footer />
      {showFAQ && <FAQ />}
    </Root>
  );
};

export default EarlyAccess;
